import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const Break: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <g fill={props?.fill ?? '#1E1E1E'} clipPath='url(#a)'>
        <path d='M15.445 12.703a4.871 4.871 0 0 0-.923-2.23l-.946.945-.994-.994.946-.946a4.871 4.871 0 0 0-2.231-.923v1.336H9.89V8.555c-.83.12-1.589.442-2.231.923l.945.946-.994.994-.945-.946a4.871 4.871 0 0 0-.923 2.231h1.335v1.406H5.743c.12.83.441 1.589.923 2.231l.945-.945.994.994-.945.945a4.872 4.872 0 0 0 2.23.923v-1.335h1.407v1.335a4.871 4.871 0 0 0 2.23-.923l-.945-.945.994-.994.946.945a4.871 4.871 0 0 0 .923-2.23h-1.336v-1.407h1.336Zm-4.851 2.813a2.112 2.112 0 0 1-2.11-2.11c0-1.163.947-2.11 2.11-2.11 1.163 0 2.11.947 2.11 2.11 0 1.163-.947 2.11-2.11 2.11ZM19.479 11.297H24C23.647 5.267 18.732.353 12.703 0v4.521a9.138 9.138 0 0 1 6.776 6.776Z' />
        <path d='M10.594 12.703a.704.704 0 1 0 0 1.407.704.704 0 0 0 0-1.407Z' />
        <path d='m18.31 12.703-.1-.586a7.727 7.727 0 0 0-6.327-6.328l-.586-.099V2.91c-.235-.015-.47-.05-.703-.05C4.778 2.86 0 7.59 0 13.406 0 19.222 4.778 24 10.594 24S21.14 19.222 21.14 13.406c0-.234-.035-.468-.05-.703H18.31Zm-7.716 7.031a6.335 6.335 0 0 1-6.328-6.328 6.335 6.335 0 0 1 6.328-6.328 6.335 6.335 0 0 1 6.328 6.328 6.335 6.335 0 0 1-6.328 6.328Z' />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default Break
